// extracted by mini-css-extract-plugin
export var attachment = "_k7-a";
export var emailContainer = "_k7-4";
export var emailContentPaddedContainer = "_k7-b";
export var emailHeader = "_k7-6";
export var emailIframe = "_k7-3";
export var emailInfoIcon = "_k7-9";
export var emailShortenedSummary = "_k7-e";
export var infoDropdown = "_k7-0";
export var infoRowBoundedContent = "_k7-d";
export var internal = "_k7-5";
export var merchant = "_k7-8";
export var messageInputContainer = "_k7-h";
export var normal = "_k7-7";
export var replyCard = "_k7-f";
export var subtleButton = "_k7-1";
export var subtleButtonIconContainer = "_k7-2";
export var toggleViewRepliesButton = "_k7-c";
export var wrappingText = "_k7-g";